<template>
  <div >
    <MMP_GTP_Tracking_ReportModal
      :gtpColumns="gtpColumns"
      :gtpRows="gtpRows"
      @showDetailsModal="$bvModal.show('detailsModal')"
      @updatedCoordinates="updateCoordinates($event)"
      @updatedGTPDetailsRows="gtpDetailsRows = $event"
    ></MMP_GTP_Tracking_ReportModal>
    <MMP_GTP_Tracking_DetailsModal
      :gtpDetailsRows="gtpDetailsRows"
      :lat="lat"
      :long="long"
    ></MMP_GTP_Tracking_DetailsModal>
  </div>
</template>

<script>
import axios from 'axios'
import MMP_GTP_Tracking_DetailsModal from './MMP_GTP_Tracking_DetailsModal.vue'
import MMP_GTP_Tracking_ReportModal from './MMP_GTP_Tracking_ReportModal.vue'

export default {
  name: 'MMP_GTP_Tracking',
  components: {
    MMP_GTP_Tracking_DetailsModal,
    MMP_GTP_Tracking_ReportModal
  },
  data() {
    return {
      gtpRows: [],
      gtpDetailsRows: [],
      gtpColumns: [
        {
          label: 'Id',
          name: 'id',
          sort: true
        },
        {
          label: '',
          name: 'expand',
          sort: false
        },
        {
          label: '',
          name: 'show',
          sort: false
        },
        {
          label: 'Valid',
          name: 'valid',
          sort: false
        },
        {
          label: 'Comments',
          name: 'comments',
          sort: false
        },
        {
          label: 'Reviewer',
          name: 'reviewer',
          sort: false
        },
        {
          label: 'Subcountry',
          name: 'subcountry',
          sort: true
        },
        {
          label: 'Date Reviewed',
          name: 'date_reviewed',
          sort: true
        },
        {
          label: 'Priority',
          name: 'variant',
          sort: true
        }
      ],
      lat: null,
      long: null,
      mapGTP: null
    }
  },
  methods: {
    getGTPTracking() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/gtp_tracking/getGTPTracking', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(content.errors)
            } else {
              let nineMonthsAgo = new Date(
                new Date(Date.now()).setMonth(
                  new Date(Date.now()).getMonth() - 10
                )
              )
              let oneYearAgo = new Date(
                new Date(Date.now()).setFullYear(
                  new Date(Date.now()).getFullYear() - 1
                )
              )
              this.gtpRows = content.rows.map(row => {
                let collected = new Date(row['date_collected'])
                if (collected < oneYearAgo) {
                  row['variant'] = '2'
                  return row
                }
                if (collected >= oneYearAgo && collected <= nineMonthsAgo) {
                  row['variant'] = '1'
                  return row
                } else {
                  row['variant'] = '0'
                  return row
                }
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    updateCoordinates(coords) {
      this.lat = coords.lat
      this.long = coords.long
    }
  },
  mounted() {
    this.getGTPTracking()
  }
}
</script>
